import { useEffect, useState } from "react";

const currentYm = () => new Intl.DateTimeFormat("en-CA", {
  timeZone:"Asia/Tokyo", year:"numeric", month:"2-digit",
}).format(new Date()).slice(0, 7);

export default function BillingPersonFacilityUsers({ storeId, request, initialYearMonth, yearMonth, onYearMonthChange, showList = true }) {
  const [localYearMonth, setLocalYearMonth] = useState(initialYearMonth || currentYm);
  const ym = yearMonth ?? localYearMonth;
  const [serviceUsers, setServiceUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setServiceUsers([]);
    setError("");

    if (!storeId) {
      setLoading(false);
      return () => { active = false; };
    }

    setLoading(true);
    Promise.resolve()
      .then(()=>request(`/jippi.php?action=entry-options&storeId=${encodeURIComponent(storeId)}&ym=${encodeURIComponent(ym)}`))
      .then(data=>{
        if (!active) return;
        setServiceUsers(Array.isArray(data?.service_users) ? data.service_users : []);
      })
      .catch(requestError=>{
        if (!active) return;
        setServiceUsers([]);
        setError(requestError?.message || "利用者一覧を取得できませんでした。");
      })
      .finally(()=>{
        if (active) setLoading(false);
      });

    return () => { active = false; };
  }, [storeId, ym, request]);

  if (!showList) return null;

  return <section aria-label="施設別利用者一覧" style={{ marginBottom:16, padding:14, border:"1px solid #dbe3ea", borderRadius:10, background:"#fff" }}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"end", gap:10, flexWrap:"wrap" }}>
      <div>
        <div style={{ fontWeight:900 }}>施設に所属する利用者</div>
        <div style={{ marginTop:3, color:"#64748b", fontSize:12 }}>表示専用です。金額や請求状態は変更しません。</div>
      </div>
      <label style={{ fontSize:11, color:"#475569" }}>対象月
        <input aria-label="施設別利用者対象月" type="month" value={ym} onChange={event=>{
          const next = event.target.value;
          if (yearMonth === undefined) setLocalYearMonth(next);
          onYearMonthChange?.(next);
        }} style={{ display:"block", minHeight:38, marginTop:4 }}/>
      </label>
    </div>
    {loading && <div role="status" style={{ marginTop:12, color:"#475569" }}>利用者を読み込み中…</div>}
    {error && <div role="alert" style={{ marginTop:12, color:"#991b1b" }}>{error}</div>}
    {!loading && !error && storeId && serviceUsers.length === 0 && <div style={{ marginTop:12, color:"#64748b" }}>対象月に所属する利用者はいません。</div>}
    {!loading && !error && serviceUsers.length > 0 && <ul style={{ display:"grid", gap:8, margin:"12px 0 0", padding:0, listStyle:"none" }}>
      {serviceUsers.map(user=><li key={user.id} style={{ padding:"9px 11px", border:"1px solid #e2e8f0", borderRadius:8, background:"#f8fafc" }}>
        <strong>{user.name}</strong>
        <div style={{ marginTop:2, color:"#64748b", fontSize:11 }}>利用者ID: {user.id}</div>
      </li>)}
    </ul>}
  </section>;
}
